<div class="sec-container">
  <h2>{{ "main.packages.title" | translate }}</h2>
  <div class="packages">
    <div class="row">
      <div class="col-12">
        <div class="subtitle">
          Стоимость изготовления цифрового памятника 200 бел.руб
        </div>
      </div>
      <div class="col-lg-5 col-sm-12 main-services">
        <div class="service-include">
          <div class="services-title">В услугу входит:</div>
          <div class="row">
            <div class="col-12 service-container">
              <img src="assets/package-quill-icon.svg" alt="" />
              <div>
                <div class="service-name">размещение некролога</div>
                <div class="service-description">
                  (до 2000 символов и подписка сроком на 2 года на хранение
                  данных)
                </div>
              </div>
            </div>
            <div class="col-12 service-container">
              <img src="assets/package-link-icon.svg" alt="" />
              <div>
                <div class="service-name">
                  размещение ссылок на сторонние источники с информацией об
                  усопшем
                </div>
                <div class="service-description">
                  (сайты, видеохостинги и тд)
                </div>
              </div>
            </div>
            <div class="col-12 service-container">
              <img src="assets/package-image-icon.svg" alt="" />
              <div>
                <div class="service-name">размещение фото</div>
                <div class="service-description">(до 10 фотографий)</div>
              </div>
            </div>
            <div class="col-12 service-container">
              <img src="assets/package-qr-icon.svg" alt="" />
              <div>
                <div class="service-name">изготовление таблички с QR-кодом</div>
                <div class="service-description">
                  (70*70 мм, нержавеющая сталь)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-sm-12">
        <div class="additional-services">
          <div class="services-title">Дополнительные услуги</div>
          <div class="additional-services-subtitle">
            Перечисление с возможностью выбора и мгновенным подсчетом общей
            суммы.
          </div>
          <ul class="row">
            <li class="col-md-6 col-sm-12">
              <div class="li-title">Cтудийная съемка биографического видео</div>
              <div class="li-subtitle">(уточняйте стоимость у менеджера)</div>
            </li>
            <li class="col-md-6 col-sm-12">
              <div class="li-title">Заказ семейной биографии</div>
              <div class="li-subtitle">(помощь копирайтера)</div>
            </li>
            <li class="col-md-6 col-sm-12">
              <div class="li-title">
                Видеомонтаж из архивных материалов - до 60 секунд - 900 бел.руб.
              </div>
              <div class="li-subtitle">(создание видео фильма)</div>
            </li>
            <li class="col-md-6 col-sm-12">
              <div class="li-title">
                Допечатка табличек / замена - 100 бел.руб.
              </div>
            </li>
            <li class="col-md-6 col-sm-12">
              <div class="li-title">
                Изменение формы и материала таблички под запрос клиента
              </div>
              <div class="li-subtitle">
                (индивидуально- после связи с менеджером)
              </div>
            </li>
            <li class="col-md-6 col-sm-12">
              <div class="li-title">
                Дополнительная/редактирование информация на страничке
              </div>
              <div class="li-subtitle">(редактирвоание больше 1го раза )</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="w-100 d-flex justify-content-center flex-wrap">
        <button (click)="viewExample()" class="cta-btn-secondary mb-2">
          Примеры
        </button>
        <button (click)="order()" class="cta-btn-primary mb-2">Заказать</button>
      </div>
    </div>
  </div>
</div>
